<template>
  <div class="flex min-h-screen w-full flex-col justify-between pt-20">
    <NuxtErrorBoundary>
      <AppNavigation />
    </NuxtErrorBoundary>

    <NuxtErrorBoundary>
      <FieldsetHeroModule :data="data" />
      
    </NuxtErrorBoundary>

    <NuxtErrorBoundary>
      <AppFooter />
    </NuxtErrorBoundary>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t: $t } = useI18n()

const props = defineProps<{
  error: any
}>()

const globals = await useInjectableGlobals().catch((error) => {
  throw createError({
    fatal: true,
    statusCode: error?.status ?? 500,
    message: error instanceof Error ? error.message : 'Couldn\'t fetch globals',
  })
})

provide(GlobalsKey, globals)

// Provide isHero to FieldsetHeroModule to render a h1 instead of h2
provide('isHero', true)

const data = {
  type: 'hero',
  id: 'error',
  heading: props.error.statusCode === 404 ? $t('error.404.heading') : $t('error.500.heading'),
  lead: props.error.statusCode === 404 ? $t('error.404.lead') : $t('error.500.lead'),
  link_text: $t('error.backToHomepage'),
  link: '/',
  text_position: {
    value: 'right',
  },
  media_type: {
    value: 'image',
  },
  image: {
    id: 'assets::errors/error_bg.jpg',
    alt_de: '',
    alt_fr: '',
    permalink: 'https://s3.eu-central-2.wasabisys.com/files.wetrok.ch/p/assets/errors/error_bg.jpg',
    extension: 'jpg',
    is_image: true,
    width: 6729,
    height: 4486,
    focus_css: '50% 80%',
  },
  video: {
    id: '',
    alt_de: '',
    alt_fr: '',
    permalink: '',
    extension: '',
    is_image: false,
    width: 0,
    height: 0,
    focus_css: '',
  },
  cover_image: {
    id: '',
    alt_de: '',
    alt_fr: '',
    permalink: '',
    extension: '',
    is_image: false,
    width: 0,
    height: 0,
    focus_css: '',
  },
}

// Ensure data is available on both server and client
if (import.meta.server) {
  await Promise.resolve(data)
}
</script>
